import * as React from 'react';
import { State } from '~/store/types';
import connect from '~/store/connect';
import { ChartFilter, Line, OldLineChart } from '@watcherr/charts';
import { Panel } from '@ixicare/ui';

import { alertActivityFilters } from '~/config/dashboard';
import Tooltip from './Tooltip';

interface DashboardAlertActivityContainerProps {
  lines: Line[];
  loading: boolean;
  filter: State['graphs']['alertActivity']['filter'];
  filterChanged: State['graphs']['alertActivity']['filterChanged'];
  tooltipWithTimestamp: boolean;
  loadData: () => void;
}

const DashboardAlertActivityContainer: React.FC<DashboardAlertActivityContainerProps> = ({
  lines,
  loadData,
  loading,
  filter,
  filterChanged,
  tooltipWithTimestamp,
}) => {
  React.useEffect(() => {
    loadData();
  }, []);

  const getTooltipContent = React.useCallback(
    (x: Date) => <Tooltip tooltipWithTimestamp={tooltipWithTimestamp} lines={lines} xValue={x} />,
    [lines]
  );

  return (
    <>
      <Panel.Right>
        <ChartFilter value={filter} onChange={filterChanged} items={alertActivityFilters} />
      </Panel.Right>
      <OldLineChart lines={lines} loading={loading} getTooltipContent={getTooltipContent} />
    </>
  );
};

export default connect((state: State) => ({
  lines: state.graphs.alertActivity.lines,
  tooltipWithTimestamp: state.graphs.alertActivity.tooltipWithTimestamp,
  loadData: state.graphs.alertActivity.loadData,
  loading: state.graphs.alertActivity.loading,
  filter: state.graphs.alertActivity.filter,
  filterChanged: state.graphs.alertActivity.filterChanged,
}))(DashboardAlertActivityContainer);
